<!--
 * @Descripttion: 关联查询组件
 * @Author: zenghua.wang
 * @Date: 2021-06-07 09:28:59
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-04-07 10:54:03
-->
<template>
  <div
    :class="setClass()"
    :style="styleSize"
  >
    <el-form
      :class="setClass('serch')"
      inline
      :size="option.size"
      @submit.native.prevent
      label-width="120px"
      label-suffix="："
      :ref="id"
    >
      <div :class="setClass('serch__input')">
        <template v-if="isSearch">
          <template v-for="(item, index) in option.column">
            <el-form-item
              :key="index"
              :label="item.label"
            >
              <!-- text -->
              <template v-if="item.type === 'text'">
                <el-input
                  placeholder="请输入"
                  clearable
                  v-model="params[index]"
                ></el-input>
              </template>

              <!-- number -->
              <template v-if="item.type === 'number'">
                <el-input
                  placeholder="请输入"
                  clearable
                  v-model="params[index]"
                ></el-input>
              </template>

              <!-- select -->
              <template v-if="item.type === 'select'">
                <el-select
                  v-model="params[index]"
                  clearable
                  :multiple="item.multiple"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="dic in item.dicData"
                    :key="dic.value"
                    :label="dic.label"
                    :disabled="dic.disabled"
                    :value="dic.value"
                  ></el-option>
                </el-select>
              </template>

              <!-- date -->
              <template v-if="item.type === 'date'">
                <el-date-picker
                  v-model="params[index]"
                  type="date"
                  placeholder="请选择"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </template>

              <!-- cascader -->
              <template v-if="item.type === 'cascader'">
                <el-cascader
                  v-model="params[index]"
                  :options="item.dicData"
                  filterable
                  clearable
                  placeholder="请选择"
                ></el-cascader>
              </template>

              <!-- datetime -->
              <template v-if="item.type === 'datetime'">
                <el-date-picker
                  v-model="params[index]"
                  type="datetime"
                  placeholder="请选择"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </template>

              <!-- daterange -->
              <template v-if="item.type === 'daterange'">
                <el-date-picker
                  v-model="params[index]"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="请选择"
                  end-placeholder="请选择"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </template>
            </el-form-item>
          </template>
        </template>

        <el-form-item v-else>
          <el-input placeholder="请输入"></el-input>
        </el-form-item>
      </div>

      <div :class="setClass('serch__action')">
        <el-form-item>
          <el-button
            :size="option.size"
            v-if="option.searchBtn"
            type="primary"
            icon="el-icon-search"
            @click="onSearch"
          >
            查询
          </el-button>
          <el-button
            :size="option.size"
            v-if="option.clearBtn"
            icon="el-icon-delete"
            @click="onSearchClear"
          >
            清空
          </el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import bem from '@/dragComponents/mixins/bem'
import { component } from '@/dragComponents/model/default.js'
import { deepClone, isEmpty, setPx } from '@/dragComponents/utils'

export default {
  name: 'drag-condition',
  mixins: [bem],
  inject: ['category', 'device'],
  props: {
    id: {
      type: String
    },
    width: {
      type: [Number, String],
      default: '100%'
    },
    height: {
      type: [Number, String],
      default: '100%'
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    select: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      params: []
    }
  },
  computed: {
    styleSize() {
      const { design } = component
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              background: this.category === 'report' ? design.bg : 'none',
              border: (() => {
                return this.styleActive ? design.activeDashed : '0'
              })()
            }
          }
          return {}
        })(),
        {
          width: isNaN(this.width) ? 'auto' : setPx(this.width),
          height: isNaN(this.height) ? 'auto' : setPx(this.height)
        }
      )
    },
    styleActive() {
      return !this.disabled && this.select.prop === this.id
    },
    isSearch() {
      return this.option.column.length > 0
    }
  },
  methods: {
    getRelationshipById(refs = [], filter = true, list = []) {
      if (isEmpty(refs) || isEmpty(this.option.relationship)) return null
      if (filter) {
        refs = refs.filter((el) => {
          return el.id && el.id !== this.id
        })
        refs = refs.filter((el) => {
          let bool =
            el.id.includes('echart') ||
            el.id.includes('column') ||
            el.id.includes('grid')
          return bool
        })
      }
      refs.forEach((item) => {
        if (this.option.relationship.includes(item.id)) {
          list.push(item)
        }
        if (!isEmpty(item.$children)) {
          this.getRelationshipById(item.$children, false, list)
        }
      })
      return list
    },
    onSearch() {
      let conditions = deepClone(this.option.column)
      conditions.forEach((item, index) => {
        item.value = this.params[index]
      })
      conditions = conditions.filter((item) => {
        return !isEmpty(item.value)
      })
      // refs => el-form
      let refs = this.$parent.$parent.$parent.$children
      let components = this.getRelationshipById(refs, false, [])
      // console.log(226, refs, components, conditions)
      if (!isEmpty(components)) {
        components.forEach((ref) => {
          ref.loadDataList(conditions)
        })
      }
    },
    onSearchClear() {
      this.params = []
      this.onSearch()
    },
    // 加载字典
    loadDictory() {
      let dicList = this.option.column.filter((item) => {
        return item.dicFrom === '动态' && item.dicUrl && item.dicMethod
      })
      if (isEmpty(dicList)) return
      dicList.forEach((item) => {
        this.$http({
          method: item.dicMethod,
          url: item.dicUrl,
          data: {},
          params: {}
        })
          .then((res) => {
            if (res.code === 200) {
              item.dicData = res.data
            }
          })
          .catch((err) => {
            this.$message.error(err.msg)
          })
      })
    }
  },
  created() {
    this.loadDictory()
  }
}
</script>
<style lang="scss" scoped>
@import '@/dragComponents/styles/variables.scss';

.drag-condition {
  padding: 20px 0;
  box-sizing: border-box;
  transition: all 0.5s;
  overflow: hidden;

  &-serch {
    padding: 0 10px;
    display: table;

    &__input,
    &__action {
      display: table-cell;
    }

    &__input {
      min-width: 100px;
    }

    &__action {
      white-space: nowrap;
    }
  }
}
</style>
